// extracted by mini-css-extract-plugin
export default {"root":"Textarea_root__rDJei","rootError":"Textarea_rootError__8Q8Ie","wrapper":"Textarea_wrapper__DHpYf","error":"Textarea_error__0wD0Z","counter":"Textarea_counter__9rKb6"};